import { Component, Input, OnInit } from '@angular/core';
import { NavController } from '@ionic/angular';
import { AnalyticsService } from 'src/app/services/analytics/analytics.service';

@Component({
  selector: 'tours-and-experiences-card',
  templateUrl: './tours-and-experiences-card.component.html',
  styleUrls: ['./tours-and-experiences-card.component.scss'],
})
export class ToursAndExperiencesCardComponent implements OnInit {
  @Input() isMarginRight?: boolean;
  @Input() width: any;
  @Input() height: any;
  @Input() service: any;
  currencyCode: any;

  constructor(
    private navController: NavController,
    private analyticsService: AnalyticsService
  ) {}

  ngOnInit() {
    this.currencyCode = this.service?.currency;
  }

  navigateToServiceDetailsPage() {
    this.analyticsService.trackUnified('service_card_clicked', {
      flow: 'tours_and_experiences',
      outcome: 'success',
      legacy_event_name: 'service_card_clicked',
      serviceId: this.service?.serviceid,
    });
    this.navController.navigateForward(
      `/tours-and-experiences/service-details/${this.service?.serviceid}`
    );
  }
}
